import React from "react";
import { IconType } from "react-icons";

interface MetricCardProps {
	label: string;
	value: string;
	change: string;
	changeText: string;
	icon: IconType;
	testId: string;
}

export default function MetricCard({
	label,
	value,
	change,
	changeText,
	icon: Icon,
	testId
}: MetricCardProps) {
	return (
		<div className="metric-card" data-testid={testId}>
			<div className="metric-header">
				<span className="metric-label">{label}</span>
				<span className="metric-icon">
					<Icon />
				</span>
			</div>
			<div className="metric-value">{value}</div>
			<div className="metric-change">
				<span className={parseFloat(change) >= 0 ? "change-positive" : "change-negative"}>
					{change}
				</span>{" "}
				{changeText}
			</div>
		</div>
	);
}
